const romanNumerals: [string, number][] = [
    ["M", 1000],
    ["CM", 900],
    ["D", 500],
    ["CD", 400],
    ["C", 100],
    ["XC", 90],
    ["L", 50],
    ["XL", 40],
    ["X", 10],
    ["IX", 9],
    ["V", 5],
    ["IV", 4],
    ["I", 1]
];

export function toRomanNumeral(num: number, uppercase?: boolean): string {
    let result = "";
    let currentNum = num;

    for (const [letter, value] of romanNumerals) {
        while (currentNum >= value) {
            result += letter;
            currentNum -= value;
        }
    }

    return uppercase ? result.toUpperCase() : result.toLowerCase();
}
